import {
  create,
  getStyle,
} from '@/utils/dom'
import { POSITION_VALUE_LIST } from '@/constant/css'
import Vue from 'vue'
import CLoading from '../components/CLoading'

const CLoadingSpin = Vue.extend(CLoading)

const setStyle = (dom, value) => {
  dom.style.position = 'absolute'
  dom.style.top = 0
  dom.style.left = 0
  dom.style.zIndex = value ? 1000 : -1 // loading和empty同时存在时loading比empty优先显示
  dom.style.opacity = value ? 1 : 0
  dom.style.transition = 'opacity .3s ease'
}

export default {
  inserted (el, { value, modifiers: { textless, nospin } }) {
    if (!POSITION_VALUE_LIST.includes(getStyle(el, 'position'))) {
      el.style.position = 'relative'
    }

    const $loading = create('div')

    el.appendChild($loading)
    const cLoading = new CLoadingSpin({
      el: $loading,

      propsData: {
        noSpin: nospin,
        loadingText: textless
          ? ''
          : typeof value === 'boolean'
            ? value ? '加载中...' : ''
            : value,
      },
    })

    el.textless = textless
    el.$loading = cLoading.$el
    el.$vm = cLoading

    setStyle(el.$loading, value)
  },

  update (el, { value }) {
    if (value) {
      if (el.$loading) {
        el.$loading.style.opacity = 1
        el.$loading.style.zIndex = 1000

        if (!el.textless) {
          if (typeof value === 'boolean') {
            if (value) {
              el.$vm.loadingText = '加载中...'
            } else {
              el.$vm.loadingText = ''
            }
          } else {
            el.$vm.loadingText = value
          }
        }
      }

      // if (typeof value === 'string') {
      //   cLoading.loadingText = value
      //   cLoading._watcher.evaluate()
      //   console.log(cLoading)
      // }
    } else {
      if (el.$loading) {
        el.$loading.style.opacity = 0
        el.$loading.style.zIndex = -1
      }
    }
  },

  unbind (el, { value }) {
    if (el.$loading) {
      // eslint-disable-next-line no-unused-expressions
      el.$loading.__vue__?.$destroy()
      el.removeChild(el.$loading)
      delete el.$loading
    }
  },
}
